module.exports = __webpack_public_path__ + "img/silver-medal.ac9c8344.png";